const stateKey = '__flow.state';
export const getPersistedState = (): any => {
    try {
        const serializedState = localStorage.getItem(stateKey);
        if (serializedState) {
            return JSON.parse(serializedState);
        }
    } catch (e) {/* ignore */}
    return {};
};
export const persistState = (state: any) => {
    console.log('call to persist state', state);

    try {
        localStorage.setItem(stateKey, JSON.stringify({
            layout: {
                ...state?.layout
            }
        }));
    } catch (e) {/* ignore */}
}